// extracted by mini-css-extract-plugin
export default {"verifyDiv":"Verify_verifyDiv__fQnDE"};